import dynamic from 'next/dynamic';

export const UserProvider = dynamic(() => import('./UserProvider'), { ssr: false });
